import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { DeleteOrgPaymentsCreditCardApiArg } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_DELETE_CARD_SERVER, SUCCESS_DELETE_CARD_SERVER } from '@/app/module/payments/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteCreditCard = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const [mutate, res] = esApi.endpoints.deleteOrgPaymentsCreditCard.useMutation()

  const deleteCard = useCallback(
    async (ccid: DeleteOrgPaymentsCreditCardApiArg['ccid']) => {
      try {
        await mutate({ orgId: orgId.toString(), ccid }).unwrap()
        dispatch(
          createNotification({
            'delete-card': {
              type: 'success',
              message: SUCCESS_DELETE_CARD_SERVER,
            },
          }),
        )
        return true
      } catch {
        dispatch(
          createNotification({
            'delete-card': {
              type: 'error',
              message: ERROR_DELETE_CARD_SERVER,
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch, mutate],
  )

  return [deleteCard, res] as const
}
